import React from 'react';
import PropTypes from 'prop-types';
import Loader from '../icons/loader';
import './coupon.m.css';

const Coupon = ({
  couponCode,
  couponDetail,
  themePrefix,
  isDisabled,
  couponOnClick,
  isLoading,
  spaceBetween
}) => {
  return (
    <div styleName="coupon-wrapper-container">
      <div styleName="coupon-wrapper">
        <button
          onClick={couponOnClick}
          disabled={isDisabled}
          styleName={`${themePrefix}coupon-code coupon-code`}
          data-testid="code-button"
        >
          {isLoading ? <Loader width="24" /> : couponCode}
        </button>
        <p
          styleName={`${themePrefix}coupon-detail coupon-detail`}
          style={spaceBetween ? { marginLeft: spaceBetween } : {}}
        >
          {couponDetail}
        </p>
      </div>
      <hr styleName={`${themePrefix}coupon-divider coupon-divider`} />
    </div>
  );
};

Coupon.propTypes = {
  couponCode: PropTypes.string.isRequired,
  couponDetail: PropTypes.string.isRequired,
  themePrefix: PropTypes.string,
  isDisabled: PropTypes.bool,
  couponOnClick: PropTypes.func,
  isLoading: PropTypes.bool,
  spaceBetween: PropTypes.string
};

export default Coupon;
